module.exports = __webpack_public_path__ + "assets/img/img-map-okinawa.4472ba00.svg";